(function () {
  'use strict';

  var CAP = 3;
  var MSG = 'You can choose up to 3 free samples in total. Please adjust your selection.';
  var CHECKOUT_SEL = '[name="checkout"]';
  var RECHECK_MS = 5000;

  var cart = { items: [] };
  var sampleTotal = 0;
  var verified = false;   // true only right after a fresh, confirmed cart.js read
  var recheckTimer = null;

  function recompute() {
    sampleTotal = (cart.items || []).reduce(function (n, l) {
      return l.price === 0 ? n + l.quantity : n;
    }, 0);
  }

  function lockCheckout() {
    verified = false;
    paintCheckout();
    // Safety net: if no cart update event follows a lock, re-verify anyway
    // so the button can't stay stuck disabled.
    clearTimeout(recheckTimer);
    recheckTimer = setTimeout(getCart, RECHECK_MS);
  }

  function getCart() {
    clearTimeout(recheckTimer);
    return fetch('/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        cart = c; recompute(); verified = true; paintCheckout();
        return c;
      })
      .catch(function () { verified = false; paintCheckout(); });
  }

  function paintCheckout() {
    // Locked until verified AND known-compliant. Fail closed, not open.
    var over = !verified || sampleTotal > CAP;
    // Express buttons can't be disabled; po-sample-cap.css hides them via these.
    var root = document.documentElement.classList;
    root.toggle('po-sample-pending', !verified);
    root.toggle('po-sample-over', verified && sampleTotal > CAP);
    document.querySelectorAll(CHECKOUT_SEL).forEach(function (btn) {
      btn.disabled = over;
      btn.setAttribute('aria-disabled', String(over));
      var note = btn.parentNode && btn.parentNode.querySelector('.sample-cap-note');
      if (sampleTotal > CAP && verified) {
        if (!note && btn.parentNode) {
          note = document.createElement('p');
          note.className = 'sample-cap-note';
          note.textContent = MSG;
          note.style.cssText =
            'display:block; width:100%; flex:1 1 100%; box-sizing:border-box;' +
            'margin-top:.5rem; font-size:.85em; line-height:1.4; color:#b00020;';
          btn.parentNode.style.flexWrap = 'wrap';
          btn.parentNode.insertBefore(note, btn.nextSibling);
        }
      } else if (note) { note.remove(); }
    });
  }

  // The theme fires `cart:bundled-sections` synchronously before every cart
  // mutation (qty change, add, gift wrap, bundles, quick order), so lock then.
  document.documentElement.addEventListener('cart:bundled-sections', lockCheckout);

  // Re-verify once the theme reports the mutation settled (or failed).
  if (window.theme && theme.pubsub) {
    theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, getCart);
    theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.cartError, getCart);
  }
  document.addEventListener('cart:updated', getCart);
  document.addEventListener('ajaxProduct:added', getCart);

  // Belt-and-braces: any change on a quantity-shaped input also locks
  // immediately, before the theme's debounced update fires.
  document.addEventListener('input', function (e) {
    if (e.target && e.target.matches && e.target.matches('input[name="quantity"], input[type="number"]')) {
      lockCheckout();
    }
  }, true);

  // Hard gate on the click/submit itself, on top of the disabled state,
  // in case a theme re-enables the button in its own JS after our paint.
  function gate(e) {
    if (!verified || sampleTotal > CAP) {
      e.preventDefault();
      e.stopImmediatePropagation();
      if (verified) window.alert(MSG);
    }
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest(CHECKOUT_SEL)) gate(e);
  }, true);
  document.addEventListener('submit', function (e) {
    var s = e.submitter || document.activeElement;
    if (s && s.matches && s.matches(CHECKOUT_SEL)) gate(e);
  }, true);

  document.addEventListener('visibilitychange', function () { if (!document.hidden) getCart(); });
  lockCheckout();   // disabled the instant this script runs, before first fetch
  getCart();        // then verify
})();
